import { render, staticRenderFns } from "./ServiceReload.vue?vue&type=template&id=59712cf4&scoped=true&"
import script from "./ServiceReload.vue?vue&type=script&lang=js&"
export * from "./ServiceReload.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReload.vue?vue&type=style&index=0&id=59712cf4&scoped=true&slang=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59712cf4",
  null
  
)

export default component.exports